import React, { useEffect, useState } from 'react';
import settlementService from '../../services/settlementService';
import { limitsView } from '../../utils/settlementLimits';

/** One line under the page header: what this person may refund and discount, and what is left today. */
export const MyLimitsStrip = ({ refreshKey }) => {
  const [view, setView] = useState(null);

  useEffect(() => {
    let alive = true;
    settlementService.getMyAuthority()
      .then((res) => { if (alive) setView(res?.success ? limitsView(res.data) : null); })
      .catch(() => { if (alive) setView(null); });
    return () => { alive = false; };
  }, [refreshKey]);

  if (!view) return null;
  return (
    <div className="settle-limits" aria-label="Your refund and discount limits">
      <span className="settle-limits-title">Your limits</span>
      <span className={`settle-limit settle-limit-${view.refund.tone}`}><b>Refund</b> {view.refund.text}</span>
      <span className={`settle-limit settle-limit-${view.discount.tone}`}><b>Discount</b> {view.discount.text}</span>
    </div>
  );
};

export default MyLimitsStrip;
